import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ReactLoading from "react-loading";
import axios from "axios";
import { connect } from "react-redux";
import CarRow from "../../../components/Cars/CarRow";
import CarEditStatus from "../CarEditStatus/CarEditStatus";
import { APIURL, PAGE10 } from "../../../config/config";
import CarCalculate from "../../../components/Cars/CarCalculate";
import CarShare from "../../../components/Cars/CarShare";
import CarLeasingForm2 from "../CarLeasingForm2";
import CarLeasingFormPercent from "../CarLeasingFormPercent";
// import { logoutAndRedirect } from '../../../actions'
import {
  changeUserType,
  loginUserSuccess,
  logoutAndRedirect,
} from "../../../actions";
import CarFind from "../CarFind";
import Loading from "../../Loading";
import { AlertSuccess, AlertWarning } from "../../Alert/Alert";
import CarFind2 from "../CarFind2";

class CarList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lists: [],
      user: {},
      user_type: "",
      car_id: 0,
      action: "บันทึก",
      car: "",
      car_edit_status: {},
      toggle_car_status_edit: false,
      toggle_car_calculate: false,
      toggle_car_share: false,
      car_calculate: {},
      car_share: {},
      page: 1,
      car_edit_sell_price: {},
      toggle_car_edit_sell_price: false,
      sum_cost_all: 0,
      isLoading: false,
      count_car: 0,
      car_select: false,
      is_search: false,
      car_delete: {},
      toggle_car_status_delete: false,
      toggle_car_status_leasing: false,
      toggle_car_status_leasing2: false,
      carLeasingList: [],
      car_leasing: {},
      car_leasing2: {},
      //
      toggle_car_find: false,
      isLoadCarDown: false,
      carDown: {},
      isCarFinding: false,
      isCarFinding2: false,
      // search ตามเงื่อนไข
      branch: [],
      branch_id: "",
      car_status: [],
      car_status_id: "",
      car_structure: [],
      car_structure_id: "",
      order_by: "",
      orders: [
        { order_id: "last", order_name: "วันที่แก้ไขข้อมูลล่าสุด" },
        { order_id: "price_low", order_name: "ราคาขาย : ต่ำไปสูง" },
        { order_id: "price_high", order_name: "ราคาขาย : สูงไปต่ำ" },
        { order_id: "name_asc", order_name: "ทะเบียนรถ : ก-ฮ" },
        { order_id: "name_desc", order_name: "ทะเบียนรถ : ฮ-ก" },
        {
          order_id: "car_in_desc",
          order_name: "วันที่ซื้อรถเข้า : ใหม่ไปเก่า",
        },
        { order_id: "car_in_asc", order_name: "วันที่ซื้อรถเข้า : เก่าไปใหม่" },
        { order_id: "year_desc", order_name: "ปีรถ : ใหม่ไปเก่า" },
        { order_id: "year_asc", order_name: "ปีรถ : เก่าไปใหม่" },
        { order_id: "car_miles_asc", order_name: "เลขไมล์ : ต่ำไปสูง" },
        { order_id: "car_miles_desc", order_name: "เลขไมล์ : สูงไปต่ำ" },
      ],
      liciense_status_id: "",
      person_vat_id: "",
      toggle_car_find2: false,
    };
    this.onCarStatusEdit = this.onCarStatusEdit.bind(this);
    this.toggleCarStatusEdit = this.toggleCarStatusEdit.bind(this);
    this.onCarStatusChange = this.onCarStatusChange.bind(this);
    this.toggleCarCalculate = this.toggleCarCalculate.bind(this);
    this.onCarCalculate = this.onCarCalculate.bind(this);
    this.onCarShare = this.onCarShare.bind(this);
    this.toggleCarShare = this.toggleCarShare.bind(this);
    this.onCarShareChange = this.onCarShareChange.bind(this);
    this.onRefreshCar = this.onRefreshCar.bind(this);
    this.toggleCarDelete = this.toggleCarDelete.bind(this);
    this.onCarDelete = this.onCarDelete.bind(this);
    this.toggleCarLeasing = this.toggleCarLeasing.bind(this);
    this.onCarLeasing = this.onCarLeasing.bind(this);
    this.onCarLeasing2 = this.onCarLeasing2.bind(this);
    this.onSubmitCarLeasing = this.onSubmitCarLeasing.bind(this);
    this.searchByCarStructure = this.searchByCarStructure.bind(this);
    this.onCarExplainFormEdit = this.onCarExplainFormEdit.bind(this);
    this.onCarExplainUpdate = this.onCarExplainUpdate.bind(this);
    this.toggleCarLeasing2 = this.toggleCarLeasing2.bind(this);
    this.checkUserDelete = this.checkUserDelete.bind(this);
    //
    this.handleCarFind = this.handleCarFind.bind(this);
    this.loadCarFinding = this.loadCarFinding.bind(this);

    this.loadBranchData = this.loadBranchData.bind(this);
    this.loadCarStatusData = this.loadCarStatusData.bind(this);
    this.loadCarStructureData = this.loadCarStructureData.bind(this);
    this.getDataCarSearchWithCriteria =
      this.getDataCarSearchWithCriteria.bind(this);
    this.getDataCarSearch = this.getDataCarSearch.bind(this);
    this.searchCar = this.searchCar.bind(this);

    this.getRenderTextCarSearch = this.getRenderTextCarSearch.bind(this);
    this.onCarLicienseStatusIdChange =
      this.onCarLicienseStatusIdChange.bind(this);
    this.onCarPersonVatIdChange = this.onCarPersonVatIdChange.bind(this);
    this.onCarStarChange = this.onCarStarChange.bind(this);
    this.handleCarFind2 = this.handleCarFind2.bind(this);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillMount() {
    //const queryString = require('query-string');
    let user = JSON.parse(this.props.user);

    // console.log('user.type=', user.type)

    this.setState({
      user: user,
      user_type: user.type,
    });
  }

  loadBranchData() {
    if (this.mounted) {
      axios
        .get(APIURL + "/branch/")
        .then((res) => {
          this.setState({ branch: res.data });
        })
        .catch((error) => {
          this.setState({ branch: [] });
        });
    }
  }

  loadCarStatusData() {
    if (this.mounted) {
      axios
        .get(APIURL + "/car_status/search/0")
        .then((res) => {
          this.setState({ car_status: res.data });
        })
        .catch((error) => {
          this.setState({ car_status: [] });
        });
    }
  }

  loadCarStructureData() {
    if (this.mounted) {
      axios
        .get(APIURL + "/car_structure/")
        .then((res) => {
          this.setState({ car_structure: res.data });
        })
        .catch((error) => {
          this.setState({ car_structure: [] });
        });
    }
  }

  handleCarFind(isShow, data) {
    if (data == null) {
      // show modal
      this.setState({ toggle_car_find: isShow });
    } else {
      // find car
      console.log("data=", data);
      this.setState(
        {
          toggle_car_find: isShow,
          isLoadCarDown: true,
          carDown: data,
        },
        () => {
          this.loadCarFinding(data);
        }
      );
    }
  }

  handleCarFind2(isShow, data) {
    console.log("isShow=", isShow);
    console.log("data=", data);
    if (data == null) {
      // show modal
      this.setState({ toggle_car_find2: isShow });
    } else {
      // find car
      // console.log('data=', data)
      this.setState(
        {
          toggle_car_find2: isShow,
          // isLoadCarDown: true,
          // carDown: data
        },
        () => {
          this.loadCarFinding2(data);
        }
      );
    }
  }

  loadCarFinding(data) {
    // var uri_structure = APIURL + '/car/structure/'+user_type+'/'+structure_name;
    let uri_finding = APIURL + "/car/finding/";
    console.log(data);

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .post(uri_finding, data)
          .then((res) => {
            if (res.data.length === 0) {
              this.setState({
                isLoadCarDown: false,
                isCarFinding: true,
                isLoading: false,
              });
              AlertWarning("ไม่พบรถตามเงื่อนไข");
            } else {
              this.setState({
                lists: res.data,
                carLeasingList: [],
                isLoadCarDown: false,
                isCarFinding: true,
                isLoading: false,
              });
              AlertSuccess("พบรถตามเงื่อนไข " + res.data.length + " คัน");
            }
          })
          .catch((error) => {
            this.setState({ lists: [] });
          });
      }
    );
  }

  loadCarFinding2(data) {
    // var uri_structure = APIURL + '/car/structure/'+user_type+'/'+structure_name;
    let uri_finding = APIURL + "/car/finding2";
    // console.log(data)

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .post(uri_finding, data)
          .then((res) => {
            // console.log('===loadCarFinding')
            // console.log(res.data[0])
            if (res.data.length === 0) {
              this.setState({
                isLoadCarDown: false,
                isCarFinding2: true,
                isLoading: false,
              });
              AlertWarning("ไม่พบรถตามเงื่อนไข");
            } else {
              this.setState({
                lists: res.data,
                carLeasingList: [],
                isLoadCarDown: false,
                isCarFinding2: true,
                isLoading: false,
              });
              AlertSuccess("พบรถตามเงื่อนไข " + res.data.length + " คัน");
            }
          })
          .catch((error) => {
            this.setState({ lists: [] });
          });
      }
    );
  }

  loadCarData(page) {
    let uri = "";
    let username = this.state.user.user;

    if (typeof page === "undefined") page = 1;

    if (this.state.user_type === "admin") {
      uri = APIURL + "/car/page/" + page + "/" + username;
    } else if (this.state.user_type === "sale") {
      // uri = APIURL + '/carsale/page/'+page;
      uri = APIURL + "/car/page/" + page + "/" + username;
    } else if (this.state.user_type === "subsale") {
      // subsale
      uri = APIURL + "/car/page/" + page + "/" + username;
    } else if (this.state.user_type === "manager") {
      uri = APIURL + "/car/page/" + page + "/" + username;
    } else if (this.state.user_type === "freelance") {
      uri = APIURL + "/car/page/" + page + "/" + username;
    } else if (this.state.user_type === "technician") {
      uri = APIURL + "/cartechnician/page/" + page;
    }

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .get(uri)
          .then((res) => {
            let result = res.data;
            let cars = result.cars;
            let carcount = result.carcount;

            if (this.mounted) {
              let sum_cost_all = 0;

              if (carcount[0].sum_cost !== undefined) {
                let sum_cost = carcount[0].sum_cost;
                let sum_repair = carcount[0].sum_repair;
                let sum_other = carcount[0].sum_other;
                sum_cost_all = sum_cost + sum_repair + sum_other;
              }

              this.setState({
                lists: cars,
                page: page,
                carLeasingList: [],
                isLoading: false,
                isCarFinding: false,
                isCarFinding2: false,
                count_car: carcount[0].count_car,
                sum_cost_all: sum_cost_all,
              });
            }
          })
          .catch((error) => {
            //this.setState({lists: []})
          });
      }
    );
  }

  searchByCarStructure(structure_name) {
    let user_type = this.state.user_type;
    let uri_structure =
      APIURL + "/car/structure/" + user_type + "/" + structure_name;

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .get(uri_structure)
          .then((res) => {
            this.setState({
              lists: res.data,
              carLeasingList: [],
              isCarFinding2: true,
              isLoading: false,
            });
          })
          .catch((error) => {
            this.setState({ lists: [], isLoading: false });
          });
      }
    );
  }

  /* loadCountCarData() {
      var uri = ''
      if(this.state.user_type === 'admin'){
        uri = APIURL + '/car/getcount/count'
      }else if(this.state.user_type === 'sale'){
        // uri = APIURL + '/carsale/getcount/count';
        uri = APIURL + '/car/getcount/count'
      }else if(this.state.user_type === 'technician'){
        uri = APIURL + '/cartechnician/getcount/count';
      }

        axios.get(uri)
            .then(res => {
                this.setState({
                    count_car: res.data[0].count_car
                });
            }).catch(error => {
            console.log(error)
        })
    }*/

  loadCountCarData(page) {
    return;

    if (this.mounted) {
      var uri = "";
      if (this.state.user_type === "admin") {
        uri = APIURL + "/car/getcount/count";
      } else if (this.state.user_type === "sale") {
        uri = APIURL + "/car/getcount/count";
      } else if (this.state.user_type === "manager") {
        // uri = APIURL + '/carsale/getcount/count';
        uri = APIURL + "/car/getcount/count";
      } else if (this.state.user_type === "technician") {
        uri = APIURL + "/cartechnician/getcount/count";
      } else {
        uri = APIURL + "/car/getcount/count";
      }

      this.setState(
        {
          isLoading: true,
        },
        () => {
          axios
            .get(uri)
            .then((res) => {
              let sum_cost_all = 0;

              if (res.data[0].sum_cost !== undefined) {
                let sum_cost = res.data[0].sum_cost;
                let sum_repair = res.data[0].sum_repair;
                let sum_other = res.data[0].sum_other;
                sum_cost_all = sum_cost + sum_repair + sum_other;
              }

              this.setState(
                {
                  count_car: res.data[0].count_car,
                  sum_cost_all: sum_cost_all,
                },
                () => this.loadCarData(page)
              );
            })
            .catch((error) => {
              console.log(error);
              this.setState({ isLoading: false });
            });
        }
      );
    }
  }

  componentDidMount() {
    //if(this.state.load_data)

    this.mounted = true;
    this.loadCarData(1);
    this.loadCountCarData(1);
    this.checkUserDelete();

    this.loadBranchData();
    // this.loadCarStatusData()
    // this.loadCarStructureData()
  }

  checkUserDeleteLogout() {
    let user = this.state.user.user;
    let uri = APIURL + "/account/" + user;

    axios
      .get(uri)
      .then((res) => {
        if (res.data.length === 0) {
          this.onLogoutAction();
        }
      })
      .catch((error) => {
        this.onLogoutAction();
      });
  }

  checkUserDelete() {
    try {
      let user = this.state.user.user;
      let uri = APIURL + "/account/" + user;
      // console.log('user='+user)
      axios
        .get(uri)
        .then((res) => {
          if (res.data.length === 0) {
            this.onLogoutAction();
          } else {
            let data = res.data[0];

            if (data.type !== this.state.user_type) {
              let user = JSON.parse(this.props.user);
              user.type = data.type;
              user.fullname = data.fullname;
              // {"user":"bosscar","fullname":"support","type":"manager"}

              let newUserInfo = JSON.stringify(user);
              this.props.onChangeUserType(data.type, newUserInfo);

              window.location.reload(false);
            }
          }
        })
        .catch((error) => {
          this.onLogoutAction();
        });
    } catch (e) {
      this.onLogoutAction();
    }
  }

  onLogoutAction() {
    //alert('Logout');
    this.props.onLogout();
    this.props.history.push("/login");
  }

  onCarStatusEdit(car) {
    this.setState({ car_edit_status: car }, () => {
      this.toggleCarStatusEdit();
    });
  }

  toggleCarStatusEdit() {
    this.setState({
      toggle_car_status_edit: !this.state.toggle_car_status_edit,
    });
  }

  onCarStatusChange(car_id, car_status_id) {
    axios
      .put(APIURL + "/car/car_status/" + car_id, {
        car_id: car_id,
        car_status_id: car_status_id,
      })
      .then((res) => {
        this.loadCarData();
        this.toggleCarStatusEdit();
      })
      .catch((error) => {});
  }

  toggleCarCalculate() {
    this.setState({
      toggle_car_calculate: !this.state.toggle_car_calculate,
    });
  }

  toggleCarDelete() {
    this.setState({
      toggle_car_status_delete: !this.state.toggle_car_status_delete,
    });
  }

  toggleCarLeasing() {
    this.setState({
      toggle_car_status_leasing: !this.state.toggle_car_status_leasing,
    });
  }

  toggleCarLeasing2() {
    this.setState({
      toggle_car_status_leasing2: !this.state.toggle_car_status_leasing2,
    });
  }

  toggleCarShare() {
    this.setState(
      {
        toggle_car_share: !this.state.toggle_car_share,
      },
      () => {
        if (this.state.toggle_car_share === false) {
          // this.loadCarData(1)
          this.loadCountCarData(1);
        }
      }
    );
  }

  onCarCalculate(car) {
    this.setState({ car_calculate: car }, () => {
      this.toggleCarCalculate();
    });
  }
  onCarShare(car) {
    this.setState({ car_share: car }, () => {
      this.toggleCarShare();
    });
  }

  onCarDelete(car) {
    /*this.setState({car_delete: car},()=>{
      this.toggleCarDelete()
    })*/
    if (this.state.user_type === "admin") {
      let car_id = car.car_id;
      axios.delete(APIURL + "/car/" + car_id).then((res) => {
        if (res.status === 200) {
          this.toggleCarDelete();
          // this.loadCarData(1)
          this.loadCountCarData(1);
        }
      });
    }
  }

  onCarLeasing(car) {
    this.setState({ car_leasing: car }, () => {
      this.toggleCarLeasing();
    });
  }

  onCarLeasing2(car) {
    // console.log('===onCarLeasing2')
    // console.log(car)
    this.setState({ car_leasing2: car }, () => {
      this.toggleCarLeasing2();
    });
  }

  onCarShareChange(car_id) {
    //alert("onCarShareChange car.car_id="+car_id)
  }

  searchCar() {
    let search_text = this.refs.search_car_name.value;
    // alert(search_text);
    if (search_text !== "") {
      this.setState({ is_search: true }, () => {
        this.getDataCarSearch(search_text);
      });
    } else {
      this.setState({ is_search: false }, () => {
        this.loadCarData(1);
      });
    }
  }

  getDataCarSearch(search_text) {
    let uri = "";
    if (this.state.user_type === "admin") {
      uri = APIURL + "/car/search/" + search_text;
    } else if (this.state.user_type === "manager") {
      uri = APIURL + "/car/search/" + search_text;
    } else if (this.state.user_type === "sale") {
      // uri = APIURL + '/carsale/search/'+search_text;
      uri = APIURL + "/car/search/" + search_text;
    } else if (this.state.user_type === "subsale") {
      uri = APIURL + "/car/search/" + search_text;
    } else if (this.state.user_type === "technician") {
      uri = APIURL + "/cartechnician/search/" + search_text;
    } else {
      uri = APIURL + "/car/search/" + search_text;
    }

    this.setState(
      {
        isLoading: true,
      },
      () => {
        // console.log(uri)
        axios
          .get(uri)
          .then((res) => {
            this.setState({
              lists: res.data,
              isLoading: false,
            });
            //
          })
          .catch((error) => {
            this.setState({ lists: [], isLoading: false });
          });
      }
    );
  }

  onRefreshCar() {
    this.refs.search_car_name.value = "";
    this.setState({ is_search: false, isCarFinding: false }, () => {
      this.loadCarData(1);
      this.loadCountCarData(1);
    });
  }

  carDelete(car_id) {
    if (this.state.user_type === "admin") {
      axios.delete(APIURL + "/car/" + car_id).then((res) => {
        if (res.status === 200) {
          this.toggleCarDelete();
          this.loadCarData(1);
          this.loadCountCarData(1);
        }
      });
    }
  }

  onSubmitCarLeasing(e, leasingData) {
    e.preventDefault();

    var action = e.target.action.value;

    var data = {
      leasingData: leasingData,
      user: this.state.user.user,
    };

    if (action === "add") {
      axios
        .post(
          APIURL + "/car_leasing/new/" + this.state.car_leasing.car_id,
          data
        )
        .then((res) => {
          console.log(res);
          //if (res.status === 200) {
          this.toggleCarLeasing();
          this.loadCarLeasingList(this.state.car_leasing.car_id);
          //}
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (action === "edit") {
      //edit
      axios
        .put(
          APIURL + "/car_leasing/edit/" + this.state.car_leasing.car_id,
          data
        )
        .then((res) => {
          if (res.status === 200) {
            this.toggleCarLeasing();
            this.loadCarLeasingList(this.state.car_leasing.car_id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onSubmitCarLeasingOld(e) {
    e.preventDefault();

    // var leasingName = ['SCB', 'GE', 'TA', 'KK', 'TIS'];
    var action = e.target.action.value;

    var leasing_SCBM = e.target.SCBM.value === "" ? 0 : e.target.SCBM.value;
    var leasing_GEM = e.target.GEM.value === "" ? 0 : e.target.GEM.value;
    var leasing_TAM = e.target.TAM.value === "" ? 0 : e.target.TAM.value;
    var leasing_KKM = e.target.KKM.value === "" ? 0 : e.target.KKM.value;
    var leasing_TISM = e.target.TISM.value === "" ? 0 : e.target.TISM.value;

    var leasing_SCB = e.target.SCB.value === "" ? 0 : e.target.SCB.value;
    var leasing_GE = e.target.GE.value === "" ? 0 : e.target.GE.value;
    var leasing_TA = e.target.TA.value === "" ? 0 : e.target.TA.value;
    var leasing_KK = e.target.KK.value === "" ? 0 : e.target.KK.value;
    var leasing_TIS = e.target.TIS.value === "" ? 0 : e.target.TIS.value;

    var leasing_SCB2 = e.target.SCB2.value === "" ? 0 : e.target.SCB2.value;
    var leasing_GE2 = e.target.GE2.value === "" ? 0 : e.target.GE2.value;
    var leasing_TA2 = e.target.TA2.value === "" ? 0 : e.target.TA2.value;
    var leasing_KK2 = e.target.KK2.value === "" ? 0 : e.target.KK2.value;
    var leasing_TIS2 = e.target.TIS2.value === "" ? 0 : e.target.TIS2.value;

    // var leasing_MPRICE = e.target.MPRICE.value ===''? 0 : e.target.MPRICE.value;

    var data = {
      SCBM: leasing_SCBM,
      GEM: leasing_GEM,
      TAM: leasing_TAM,
      KKM: leasing_KKM,
      TISM: leasing_TISM,

      SCB: leasing_SCB,
      GE: leasing_GE,
      TA: leasing_TA,
      KK: leasing_KK,
      TIS: leasing_TIS,

      SCB2: leasing_SCB2,
      GE2: leasing_GE2,
      TA2: leasing_TA2,
      KK2: leasing_KK2,
      TIS2: leasing_TIS2,
      //'MPRICE'  : leasing_MPRICE,
      user: this.state.user.user,
    };

    if (action === "add") {
      axios
        .post(APIURL + "/car_leasing/" + this.state.car_leasing.car_id, data)
        .then((res) => {
          if (res.status === 200) {
            this.toggleCarLeasing();
            this.loadCarLeasingList(this.state.car_leasing.car_id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (action === "edit") {
      //edit
      axios
        .put(APIURL + "/car_leasing/" + this.state.car_leasing.car_id, data)
        .then((res) => {
          if (res.status === 200) {
            this.toggleCarLeasing();
            this.loadCarLeasingList(this.state.car_leasing.car_id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  loadCarLeasingList(car_id) {
    var uri = APIURL + "/car_leasing/" + car_id;
    axios
      .get(uri)
      .then((res) => {
        this.setState({ carLeasingList: res.data });
      })
      .catch((error) => {
        this.setState({ carLeasingList: [] });
      });
  }

  onCarExplainFormEdit(e, car_id) {
    e.preventDefault();
    let explain = e.target.value;

    let car_list = this.state.lists.map((car) =>
      car.car_id === car_id
        ? { ...car, car_explain: explain, car_edit: true }
        : car
    );
    this.setState({
      lists: car_list,
    });
  }

  onCarLicienseStatusIdChange(e, car_id) {
    e.preventDefault();
    let liciense_status_id = Number(e.target.value);
    // console.log('liciense_status_id=', liciense_status_id)
    let car_list = this.state.lists.map((car) =>
      car.car_id === car_id
        ? { ...car, liciense_status_id: liciense_status_id }
        : car
    );
    this.setState(
      {
        lists: car_list,
      },
      () => {
        // update to api
        let uri = APIURL + "/car/liciense_status/" + car_id;
        let data = { liciense_status_id: liciense_status_id };
        axios
          .put(uri, data)
          .then((res) => {
            // console.log(res.data)
          })
          .catch((error) => {
            console.log("error: ", error);
          });
      }
    );
  }

  onCarPersonVatIdChange(e, car_id) {
    e.preventDefault();
    let person_vat_id = Number(e.target.value);
    // console.log('person_vat_id=', person_vat_id)
    let car_list = this.state.lists.map((car) =>
      car.car_id === car_id ? { ...car, person_vat_id: person_vat_id } : car
    );
    this.setState(
      {
        lists: car_list,
      },
      () => {
        // update to api
        let uri = APIURL + "/car/person_vat/" + car_id;
        let data = { person_vat_id: person_vat_id };
        axios
          .put(uri, data)
          .then((res) => {})
          .catch((error) => {
            console.log("error: ", error);
          });
      }
    );
  }

  onCarStarChange(checked, car_id) {
    // console.log(checked, typeof checked)
    // console.log(car_id, typeof car_id)
    let is_star = checked ? 1 : 0;
    // console.log('is_star=', is_star, typeof is_star)
    let car_list = this.state.lists.map((car) =>
      car.car_id === car_id ? { ...car, is_star: is_star } : car
    );
    this.setState(
      {
        lists: car_list,
      },
      () => {
        let uri = APIURL + "/car/is_star/" + car_id;
        let data = { is_star: is_star };
        axios
          .put(uri, data)
          .then((res) => {})
          .catch((error) => {
            console.log("error: ", error);
          });
      }
    );
  }

  onCarExplainUpdate(car_id, car_explain) {
    // update car_explain
    let uri = APIURL + "/car/car_explain/" + car_id;
    let data = { car_explain: car_explain };
    axios
      .put(uri, data)
      .then((res) => {
        if (res.status === 200) {
          var car_list = this.state.lists.map((car) =>
            car.car_id === car_id
              ? { ...car, car_edit: false, car_save: true }
              : car
          );
          this.setState({
            lists: car_list,
          });

          setTimeout(() => {
            var car_list = this.state.lists.map((car) =>
              car.car_id === car_id
                ? { ...car, car_edit: false, car_save: false }
                : car
            );
            this.setState({
              lists: car_list,
            });
          }, 2000);
        }
      })
      .catch((error) => {});
  }

  getDataCarSearchWithCriteria() {
    let search_text = this.refs.search_car_name.value;
    let branch_id = this.state.branch_id;
    let car_status_id = this.state.car_status_id;
    let car_structure_id = this.state.car_structure_id;
    let order_by = this.state.order_by;
    let liciense_status_id = this.state.liciense_status_id;
    let person_vat_id = this.state.person_vat_id;
    let car_brand_id = "";
    let car_color_id = "";

    let data = {
      search_text,
      branch_id,
      car_status_id,
      car_structure_id,
      order_by,
      liciense_status_id,
      person_vat_id,
      car_brand_id,
      car_color_id,
    };

    let uri = APIURL + "/car/criteria";

    this.setState({ isLoading: true }, () => {
      axios
        .post(uri, data)
        .then((res) => {
          this.setState({ lists: res.data, isLoading: false, is_search: true });
        })
        .catch((error) => {
          console.log("error:", error);
          this.setState({ lists: [], isLoading: false });
        });
    });
  }

  getRenderTextCarSearch() {
    const {
      branch_id,
      car_status_id,
      car_structure_id,
      order_by,
      // xx
      branch,
      car_status,
      car_structure,
      orders,
      lists,
    } = this.state;

    let searchText = "ค้นหาตาม ";

    if (branch_id !== "") {
      let branch_name = branch.filter(
        (b) => b.branch_id === parseInt(branch_id, 10)
      )[0].branch_name;
      searchText += " สาขา" + branch_name;
    }

    if (car_status_id !== "") {
      let car_status_name = car_status.filter(
        (b) => b.car_status_id === parseInt(car_status_id, 10)
      )[0].car_status_name;
      searchText += " สถานะ" + car_status_name;
    }

    if (car_structure_id !== "") {
      let car_structure_name = car_structure.filter(
        (b) => b.car_structure_id === parseInt(car_structure_id, 10)
      )[0].car_structure_name;
      searchText += " สถานะ" + car_structure_name;
    }

    if (order_by !== "") {
      let order_name = orders.filter((b) => b.order_id === order_by)[0]
        .order_name;
      searchText += " เรียงตาม" + order_name;
    }

    if (lists.length > 0) {
      searchText += " พบ " + lists.length + " คัน";
    }

    return searchText;
  }

  render() {
    let all_page = Math.ceil(this.state.count_car / PAGE10);
    let page_array = Array.from(Array(all_page).keys());

    let tab_pages = page_array.map((page, index) => {
      let page_tmp = page + 1;
      return (
        <li className="page-item" key={index}>
          <a
            className="page-link"
            href="no-script-url:0"
            onClick={() => {
              this.loadCarData(page_tmp);
            }}
          >
            &nbsp;{page_tmp}&nbsp;
          </a>
        </li>
      );
    });

    /*let emptyCarList = () => {
      if(this.state.lists.length===0){
        return (
          <tbody>
           <tr><td colSpan={6} className="text-danger text-center">ไม่พบข้อมูลรถ</td></tr>
          </tbody>
        )
      }else{
        return null
      }
    }*/

    let branch_list = this.state.branch.map((branch, index) => {
      return (
        <option key={index} value={branch.branch_id}>
          {branch.branch_name}
        </option>
      );
    });

    /*

    let car_status_list = this.state.car_status.map((car_status, index) => {
      return (
        <option key={index} value={car_status.car_status_id}>{car_status.car_status_name}</option>
      )
    })

    let car_structure_list = this.state.car_structure.map((car_structure, index) => {
      return (
        <option key={index} value={car_structure.car_structure_id}>{car_structure.car_structure_name}</option>
      )
    })

    let order_list = this.state.orders.map((order, index) => {
      return (
        <option key={index} value={order.order_id}>{order.order_name}</option>
      )
    })*/

    // let width = 136
    // onChange={this.searchCar.bind(this)}
    let width = 128;

    return (
      <div className="card">
        <Loading isLoading={this.state.isLoading} />

        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-info">
                <div className="card-header">
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <select
                          className="form-control mr-1"
                          name="branch_id"
                          style={{ width: width }}
                          value={this.state.branch_id}
                          onChange={(e) => {
                            this.setState({ branch_id: e.target.value }, () =>
                              this.getDataCarSearchWithCriteria()
                            );
                          }}
                        >
                          <option value="">สาขาทั้งหมด</option>
                          {branch_list}
                        </select>
                        <select
                          className="form-control"
                          id="liciense_status_id"
                          name="liciense_status_id"
                          style={{ width: width - 20 }}
                          value={this.state.liciense_status_id}
                          onChange={(e) => {
                            // this.props.getDataCarSearchWithCriteria(e, car.car_id)
                            if (e.target.value === "") {
                              this.setState(
                                {
                                  liciense_status_id: "",
                                },
                                () => this.onRefreshCar()
                              );
                            } else {
                              this.setState(
                                { liciense_status_id: e.target.value },
                                () => this.getDataCarSearchWithCriteria()
                              );
                            }
                          }}
                        >
                          <option value="">สถานะเล่ม</option>
                          <option value="1">มีเล่ม</option>
                          <option value="5">ไม่มีเล่ม</option>
                        </select>
                        <select
                          className="form-control"
                          id="liciense_status_id"
                          name="liciense_status_id"
                          style={{ width: width - 30 }}
                          value={this.state.person_vat_id}
                          onChange={(e) => {
                            if (e.target.value === "") {
                              this.setState(
                                {
                                  person_vat_id: "",
                                },
                                () => this.onRefreshCar()
                              );
                            } else {
                              this.setState(
                                { person_vat_id: e.target.value },
                                () => this.getDataCarSearchWithCriteria()
                              );
                            }
                          }}
                        >
                          <option value="">บุคคล/vat</option>
                          <option value="1">บุคคล</option>
                          <option value="2">vat</option>
                        </select>
                        {/*<strong> ข้อมูลรถ </strong>*/}
                        <input
                          ref="search_car_name"
                          style={styles.searchCar}
                          className="form-control"
                          placeholder="ค้นหารถชื่อรถ หรือทะเบียนรก"
                          type="text"
                        />
                        &nbsp;
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={this.searchCar.bind(this)}
                          style={styles.buttonHeight}
                        >
                          <i className="icon-search"></i>&nbsp; ค้นหา
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-primary"
                          style={styles.buttonHeight}
                          onClick={this.onRefreshCar.bind(this)}
                        >
                          <i className="icon-refresh"></i>
                        </button>
                        &nbsp;&nbsp;
                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            style={{ width: 62 }}
                            onClick={() => this.searchByCarStructure("เก๋ง")}
                          >
                            เก๋ง
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            style={{ width: 62 }}
                            onClick={() => this.searchByCarStructure("กระบะ")}
                          >
                            กระบะ
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-warning"
                            style={{ width: 78 }}
                            onClick={() =>
                              this.searchByCarStructure("ตอนเดียว")
                            }
                          >
                            ตอนเดียว
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-success"
                            style={{ width: 82 }}
                            onClick={() => this.searchByCarStructure("แวน")}
                          >
                            แวน/SUV
                          </button>
                        </div>
                        &nbsp;&nbsp;
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => this.handleCarFind(true, null)}
                        >
                          <i className="icon-target"></i>&nbsp; ค้นหารถ
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => this.handleCarFind2(true, null)}
                        >
                          <i className="icon-target"></i>&nbsp; ค้นหารถ2
                        </button>
                      </div>
                    </div>
                    {/* <div className="col-1 pt-2">

                     </div>*/}
                  </div>
                </div>

                {/*<div className="card-header">
                  <div className="row">
                    <div className="form-group form-inline col-12">
                      <div className="row">
                        <select className="form-control mr-1"
                                name="branch_id"
                                style={{width: width}}
                                value={this.state.branch_id}
                                onChange={(e) => {
                                  this.setState({branch_id: e.target.value}, () => this.getDataCarSearchWithCriteria())
                                }}
                        >
                          <option value="">สาขาทั้งหมด</option>
                          {branch_list}
                        </select>

                        <select className="form-control mr-1"
                                name="car_status_id"
                                style={{width: width}}
                                value={this.state.car_status_id}
                                onChange={(e) => {
                                  this.setState({car_status_id: e.target.value}, () => this.getDataCarSearchWithCriteria())
                                }}
                        >
                          <option value="">สถานะรถ</option>
                          {car_status_list}
                        </select>

                        <select className="form-control mr-1"
                                style={{width: width}}
                                name="car_structure_id"
                                value={this.state.car_structure_id}
                                onChange={(e) => {
                                  this.setState({car_structure_id: e.target.value}, () => this.getDataCarSearchWithCriteria())
                                }}
                        >
                          <option value="">ประเภทรถ</option>
                          {car_structure_list}
                        </select>

                        <select className="form-control mr-1"
                                name="order_by"
                                style={{width: width}}
                                value={this.state.order_by}
                                onChange={(e) => {
                                  this.setState({order_by: e.target.value}, () => this.getDataCarSearchWithCriteria())
                                }}
                        >
                          <option value="">เรียงลำดับตาม</option>
                          {order_list}
                        </select>

                        <input
                          ref="search_car_name"
                          style={styles.searchCar}
                          className="form-control"
                          placeholder="ค้นหารถชื่อรถ หรือทะเบียนรก"
                          type="text"

                        />
                        &nbsp;
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => this.getDataCarSearchWithCriteria()}
                          style={styles.buttonHeight}
                        >
                          <i className="icon-search"></i>&nbsp; ค้นหา
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={this.onRefreshCar.bind(this)}
                          style={styles.buttonHeight}
                        >
                          <i className="icon-refresh"></i>
                        </button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Link to="/cars/new">
                          <button
                            className="btn btn-primary float-right"
                            style={styles.buttonHeight}
                          >
                            <i className="icon-plus"></i>&nbsp; เพิ่มรถใหม่
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>*/}

                <div className="card-block">
                  <div
                    className={
                      this.state.count_car > 0 ? "row pl-3 pb-2" : "hidden"
                    }
                  >
                    <div className="col-6">
                      {this.state.isCarFinding === true ? (
                        <h4 className="pr-3">
                          พบรถ {this.state.lists.length} คัน &nbsp;&nbsp;|
                          &nbsp;&nbsp;{this.state.carDown.carType} :
                          &nbsp;&nbsp;{this.state.carDown.carLeasing} :
                          &nbsp;&nbsp;{this.state.carDown.leasingPercent}% :
                          &nbsp;&nbsp;{this.state.carDown.carDown} :
                          &nbsp;&nbsp;{this.state.carDown.promotionOption}
                        </h4>
                      ) : this.state.isCarFinding2 === true ? (
                        <h4 className="pr-3">
                          พบรถ {this.state.lists.length} คัน &nbsp;&nbsp;
                        </h4>
                      ) : (
                        <h4 className="pr-3">
                          จำนวนรถทั้งหมด {this.state.count_car} คัน
                        </h4>
                      )}
                    </div>

                    <div className="col-6">
                      <Link to="/carin/all">
                        <button className="btn btn-info float-right ">
                          <i className="icon-eye"></i>&nbsp; รายละเอียด
                        </button>
                      </Link>

                      {this.state.user.type === "admin" ||
                      this.state.user.type === "manager" ? (
                        <Link to="/report/carin" target="_blank">
                          <button className="btn btn-success float-right mr-1">
                            รายงานรถเข้า
                          </button>
                        </Link>
                      ) : null}

                      <Link to="/cars/new">
                        <button className="btn btn-primary float-right mr-1">
                          <i className="icon-plus"></i>&nbsp; เพิ่มรถใหม่ &nbsp;
                        </button>
                      </Link>
                    </div>
                  </div>

                  {this.state.isLoadCarDown === true ? (
                    <div className="text-center">
                      <center>
                        <ReactLoading
                          type={"balls"}
                          color={"#c1c1c1"}
                          height={30}
                          width={30}
                        />{" "}
                        กำลังหารถ &nbsp;&nbsp;
                        {this.state.carDown.carType} :
                        {this.state.carDown.carLeasing} :
                        {this.state.carDown.leasingPercent} :
                        {this.state.carDown.carDown}
                      </center>
                    </div>
                  ) : null}
                  <div className={"row pl-3 pb-2"}>
                    {/*<div className="form-group form-inline col-8">

                      {
                        this.state.is_search === true ? <h5>{this.getRenderTextCarSearch()}</h5> : <h4 >จำนวนรถ {this.state.count_car} คัน</h4>
                      }

                      &nbsp;&nbsp;
                      {
                        this.state.sum_cost_all > 0 && this.state.user_type === 'admin' ?
                          <h4 >รวมทุน {this.state.sum_cost_all.toLocaleString()} บาท</h4>
                          : ''
                      }
                    </div>*/}

                    {/*<div className="form-group col-4 text-right">
                      {
                        this.state.user.type === 'admin' || this.state.user.type === 'manager' ? (
                          <Link to="/report/carin" target='_blank'>
                            <button className="btn btn-success float-right ml-1">
                              รายงานรถเข้า
                            </button>
                          </Link>
                        ) : null
                      }

                      <Link to="/carin/all" >
                        <button className="btn btn-info float-right ">
                          รายละเอียด
                        </button>
                      </Link>
                    </div>*/}
                  </div>

                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">รูปรถ</th>
                        <th className="text-center">ชื่อรถ</th>
                        {/*<th className={this.state.user_type ==='admin' ? "text-center" :  "hidden"}>ราคาทุน</th>*/}
                        <th
                          className={
                            this.state.user_type === "technician"
                              ? "hidden"
                              : "text-center"
                          }
                        >
                          ราคา
                        </th>
                        {/*<th className={this.state.user_type ==='admin' ? "text-center" :  "hidden"} >กำไร</th>
                      <th className="text-center">สถานะ</th>*/}
                        <th className="text-center">จัดการ</th>
                      </tr>
                    </thead>

                    <CarRow
                      cars={this.state.lists}
                      onCarStatusEdit={this.onCarStatusEdit}
                      onCarCalculate={this.onCarCalculate}
                      onCarShare={this.onCarShare}
                      onCarDelete={this.onCarDelete}
                      onCarLeasing={this.onCarLeasing}
                      onCarLeasing2={this.onCarLeasing2}
                      user_type={this.state.user_type}
                      carLeasingList={this.state.carLeasingList}
                      onCarExplainFormEdit={this.onCarExplainFormEdit}
                      onCarExplainUpdate={this.onCarExplainUpdate}
                      onCarLicienseStatusIdChange={
                        this.onCarLicienseStatusIdChange
                      }
                      onCarPersonVatIdChange={this.onCarPersonVatIdChange}
                      onCarStarChange={this.onCarStarChange}
                      onOpenCarAlbums={() => {
                        console.log("onOpenCarAlbums");
                      }}
                      //
                      page={this.state.page}
                      count={
                        this.state.is_search === true
                          ? this.state.lists.length
                          : this.state.count_car
                      }
                      branch={this.state.branch}
                    />
                  </table>
                  <ul
                    className={this.state.is_search ? "hidden" : "pagination"}
                  >
                    {this.state.isCarFinding === true ||
                    this.state.isCarFinding2 === true
                      ? null
                      : tab_pages}

                    {/*<li className="page-item"><a className="page-link" href="#">Prev</a></li>*/}
                    {/*<li className="page-item active"><a className="page-link" href="#">1</a>*/}
                    {/*</li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">2</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">3</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">4</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">Next</a></li>*/}
                  </ul>
                </div>
              </div>

              <Modal
                isOpen={this.state.toggle_car_status_edit}
                toggle={this.toggleCarStatusEdit}
                className={"modal-lg "}
              >
                <ModalBody>
                  <CarEditStatus
                    car={this.state.car_edit_status}
                    onHandle={{
                      cancel: this.toggleCarStatusEdit,
                      change: this.onCarStatusChange,
                    }}
                  />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={this.state.toggle_car_calculate}
                toggle={this.toggleCarCalculate}
                className={"modal-lg " + this.props.className}
              >
                <ModalBody>
                  <CarCalculate
                    car={this.state.car_calculate}
                    onToggle={this.toggleCarCalculate}
                  />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={this.state.toggle_car_share}
                toggle={this.toggleCarShare}
                className={"modal-lg " + this.props.className}
              >
                <ModalBody>
                  <CarShare
                    car={this.state.car_share}
                    onHandle={{
                      cancel: this.toggleCarShare,
                      change: this.onCarShareChange,
                    }}
                  />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={this.state.toggle_car_status_delete}
                toggle={this.toggleCarDelete}
                className={"modal-danger"}
              >
                <ModalHeader toggle={this.toggleCarDelete}>
                  ลบข้อมูล
                </ModalHeader>
                <ModalBody>
                  <strong>
                    {" "}
                    คุณต้องการลบข้อมูล {this.state.car_delete.car_name} [
                    {this.state.car_delete.car_id}] ใช่หรือไม่ ??{" "}
                  </strong>
                  <br />
                  (ข้อมูลจะไม่สามารถกู้คืนได้)
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="danger"
                    onClick={this.carDelete.bind(
                      this,
                      this.state.car_delete.car_id
                    )}
                  >
                    ตกลง
                  </Button>{" "}
                  <Button color="secondary" onClick={this.toggleCarDelete}>
                    ยกเลิก
                  </Button>
                </ModalFooter>
              </Modal>

              <Modal
                isOpen={this.state.toggle_car_status_leasing}
                toggle={this.toggleCarLeasing}
                className={"modal-md " + this.props.className}
              >
                <ModalBody>
                  {/*<CarLeasingForm
                    car={this.state.car_leasing}
                    onHandle = {
                      {
                        cancel: this.toggleCarLeasing
                      }
                    }
                    onSubmit = {this.onSubmitCarLeasingOld}
                  />*/}
                  <CarLeasingFormPercent
                    car={this.state.car_leasing}
                    onHandle={{
                      cancel: this.toggleCarLeasing,
                    }}
                    onSubmit={this.onSubmitCarLeasing}
                  />
                </ModalBody>
              </Modal>

              <Modal
                isOpen={this.state.toggle_car_status_leasing2}
                toggle={this.toggleCarLeasing2}
                className={"modal-md " + this.props.className}
              >
                <ModalBody>
                  <CarLeasingForm2
                    car={this.state.car_leasing2}
                    onHandle={{
                      cancel: this.toggleCarLeasing,
                    }}
                    onSubmit={this.onSubmitCarLeasing}
                  />
                </ModalBody>
              </Modal>

              <CarFind
                toggle_car_find={this.state.toggle_car_find}
                handleCarFind={this.handleCarFind}
              />

              {this.state.toggle_car_find2 === true && (
                <CarFind2
                  toggle_car_find={this.state.toggle_car_find2}
                  handleCarFind={this.handleCarFind2}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
/*const styles = {
    searchCar: {
        marginLeft: 20,
        width: 300,
        display: 'inline'
    },

    buttonHeight: {
        height: 32,
        paddingTop:0,
        paddingBottom:0,
        display: 'inline',
        marginTop: '-0.35rem'
    }
}*/
const styles = {
  searchCar: {
    marginLeft: 16,
    width: 180,
    // display: 'inline'
  },

  buttonHeight: {
    height: 35,
    paddingTop: 0,
    paddingBottom: 0,
    display: "inline",
    marginTop: 0,
  },
};

/*CarList.propTypes = {
  onLogout: PropTypes.func
}*/

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

// const mapDispatchToProps = (dispatch) => ({
//   onLogout() {
//     dispatch(logoutAndRedirect())
//   },
//   onChangeUserType(type, user) {
//     dispatch(changeUserType(type, user))
//   },
//   onLoginSuccess(data) {
//     dispatch(loginUserSuccess(data.token,JSON.stringify(data.user)))
//   },
// })

const mapDispatchToProps = (dispatch) => ({
  onLoginSuccess(data) {
    dispatch(loginUserSuccess(data.token, JSON.stringify(data.user)));
  },
  onChangeUserType(type, user) {
    dispatch(changeUserType(type, user));
  },
  onLogout() {
    dispatch(logoutAndRedirect());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CarList);
